import React, { useEffect, useState } from "react";
import {
  View,
  Image,
  StyleSheet,
  TouchableHighlight,
  useWindowDimensions,
  ScrollView,
} from "react-native";
import { TReturnGetImagesBatchBatchId } from "../../../services/api";

type DisplayTwoSquaresProps = {
  currentImageData: TReturnGetImagesBatchBatchId[];
  isAllProcedureDataEmpty?: boolean;
};

const DisplayTwoSquares = ({
  currentImageData,
  isAllProcedureDataEmpty = false,
}: DisplayTwoSquaresProps) => {
  const { width } = useWindowDimensions();
  const isMobile = width < 644;

  const [selectedImageData, setSelectedImageData] =
    useState<TReturnGetImagesBatchBatchId | null>(null);
  const [imageData, setImageData] = useState<TReturnGetImagesBatchBatchId[]>(
    [],
  );

  useEffect(() => {
    let filteredData: TReturnGetImagesBatchBatchId[] = [];
    if (isAllProcedureDataEmpty) {
      filteredData = currentImageData;
    } else {
      filteredData = currentImageData.filter((item) =>
        item.uploadType.includes("Transform"),
      );
    }
    if (filteredData.length === 0) return;
    setImageData(filteredData);
    setSelectedImageData(filteredData[0]);
  }, [currentImageData]);

  if (imageData && imageData.length === 0) return null;

  return (
    <View style={styles.container}>
      <View style={styles.twoImagesContainer}>
        {/* NOTE: <img /> is not react native */}
        <img
          style={styles.imageContainer}
          draggable={false}
          src={
            selectedImageData && selectedImageData.presignedUrls.length !== 0
              ? selectedImageData.presignedUrls[0]
              : ""
          }
          alt=""
        />
        <img
          style={styles.imageContainer}
          draggable={false}
          src={
            selectedImageData && selectedImageData.presignedUrls.length !== 0
              ? selectedImageData.presignedUrls[
                  selectedImageData.presignedUrls.length - 1
                ]
              : ""
          }
          alt=""
        />
      </View>
      <ScrollView
        horizontal
        style={{
          width: "100%",
        }}
        contentContainerStyle={{
          justifyContent: "center",
          alignItems: "center",
          flexGrow: 1,
        }}
      >
        {imageData.map((image, index) => (
          <TouchableHighlight
            key={index}
            onPress={() => setSelectedImageData(image)}
            style={{
              width: 90,
              aspectRatio: 1,
            }}
          >
            <Image
              style={[
                styles.image,
                image === selectedImageData && styles.selectedImageStyle,
              ]}
              source={{
                uri:
                  image && image.presignedUrls.length !== 0
                    ? image.presignedUrls[image.presignedUrls.length - 1]
                    : "",
              }}
            />
          </TouchableHighlight>
        ))}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: 14,
  },
  twoImagesContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "center",
    gap: 20,
  },
  fiveImagesContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "center",
  },
  imageContainer: {
    display: "flex",
    flex: 1,
    width: "100%",
    height: "auto",
    objectFit: "contain",
    position: "relative",
  },
  image: {
    width: "100%",
    height: "100%",
    borderRadius: 10,
    borderWidth: 5,
    borderColor: "transparent",
  },
  selectedImageStyle: {
    borderColor: "#0000004D",
    // @ts-ignore comment
    filter: "brightness(0.8)",
  },
});

export default DisplayTwoSquares;
